import { Box, Breadcrumbs, ThemeProvider } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

import React from 'react';
import { theme } from '../../theme/theme';
import { BreadcrumbUtils } from './BreadcrumbUtil';

const styles = makeStyles(() => ({
	breadcrumbs: {
		padding: '0px 4px',
	},
}));

const Breadcrumb = () => {
	const classes = styles();
	const breadcrumbs = BreadcrumbUtils();

	return (
		<ThemeProvider theme={theme}>
			<Box>
				<Breadcrumbs
					className={classes.breadcrumbs}
					separator="/"
					aria-label="breadcrumb">
					{breadcrumbs?.map((item) => item)}
				</Breadcrumbs>
			</Box>
		</ThemeProvider>
	);
};

export default Breadcrumb;
